import { render, staticRenderFns } from "./problems.vue?vue&type=template&id=36bb04d5&scoped=true&"
import script from "./problems.vue?vue&type=script&lang=js&"
export * from "./problems.vue?vue&type=script&lang=js&"
import style0 from "./problems.vue?vue&type=style&index=0&id=36bb04d5&scoped=true&lang=less&"
import style1 from "./problems.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bb04d5",
  null
  
)

export default component.exports